export default "__VITE_ASSET__DOfZinRE__"